export default "__VITE_ASSET__6cd243fd__"